import {
  LoadingOverlay as MantineLoadingOverlay,
  LoadingOverlayProps,
} from '@mantine/core';

export type ILoadingOverlayProps = LoadingOverlayProps;

/** @registry Design-layer pass-through over Mantine LoadingOverlay; import this instead of @mantine/core LoadingOverlay outside src/design. */
export const LoadingOverlay = MantineLoadingOverlay;
